module.exports = __webpack_public_path__ + "static/media/ic_nav_kontrast.efdad79d.svg";